import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";

const KanbanIcon = () => {
  return <TableChartOutlinedIcon sx={{ fill: "white" }} />;
};

export default KanbanIcon;
